import { Component } from "react"

/* QR CODE */
import { QRCodeSVG } from "qrcode.react"

/* Flyer */
import { CANVAS, fill, fadeOf, inkOf, linkOf, offerSize, pinIcon } from "./flyer"


/* Widget Flyer Sheet — one side of the leaflet. It is always laid out at the full size of the
   drawing and the stage around it only scales it by the eye, so the picture taken for the print
   stays sharp. Everything it draws comes from the props: the widget keeps no state of its own */
class FlyerSheet extends Component {

    /* The name of the point — the one typed by hand wins over the one of the base */
    name = () => {

        const { fields, organization } = this.props
        const own = `${fields.name}`.trim()

        if (own.length > 0) {
            return own
        }

        if (organization && organization.name) {
            return `${organization.name}`
        }

        return "Заведение"
    }

    /* The address of the point — the same rule */
    address = () => {

        const { fields, organization } = this.props
        const own = `${fields.address}`.trim()

        if (own.length > 0) {
            return own
        }

        if (organization && organization.address) {
            return `${organization.address}`
        }

        return ""
    }

    /* The line across the very top of both sides. The stripes are the pole of a barber, the line
       is the accent of the point itself */
    _rule = () => {

        const { fields } = this.props

        if (fields.rule === "none") {
            return null
        }

        if (fields.rule === "stripes") {
            return <div className="flyer-rule stripes" />
        }

        return <div className="flyer-rule" style={{ background: fields.accent }} />
    }

    /* The mark of the point and its name — they stand in the corner of both sides. The form says
       which of the two is drawn; a mark asked for alone but never uploaded leaves the name, so
       the corner is never empty */
    _brand = size => {

        const { fields, logo } = this.props

        const withMark = logo && fields.brand !== "text"
        const withName = fields.brand !== "logo" || !logo

        return (
            <div className={`flyer-brand ${size}`}>
                {withMark && <img src={logo} alt="Logo" className={`flyer-brand-mark ${withName ? "" : "alone"}`} />}
                {withName && <div className="flyer-brand-name">{this.name()}</div>}
            </div>
        )
    }

    /* THE FACE — the offer over the photo of the place */
    _front = () => {

        /* Fields */
        const { fields } = this.props

        const ink = fields.veil === "light" ? "dark" : "light"
        const site = "bookify.kz"

        return (
            <div className={`flyer-front ${ink}`}>

                <div className="flyer-front-inner">

                    <div className="flyer-brands">
                        {/* One logo serves both grounds: on a dark face every pixel of it is
                            turned white and only the transparency is kept */}
                        <img src="/images/bookify.png" alt="Bookify" className={`flyer-bookify ${ink === "light" ? "white" : ""}`} />
                        {this._brand("big")}
                    </div>

                    {`${fields.badge}`.trim().length > 0 &&
                        <div className="flyer-badge" style={{ background: fields.accent, color: inkOf(fields.accent) === "light" ? "#ffffff" : "#141414" }}>
                            {fields.badge}
                        </div>
                    }

                    <div className="flyer-offer">
                        <i>—</i>{`${fields.discount}`.trim()}<sup>%</sup>
                    </div>

                    {`${fields.offer}`.trim().length > 0 &&
                        <div className="flyer-offer-text" style={{ fontSize: offerSize(fields.offer) }}>{fields.offer}</div>
                    }

                    {`${fields.lead}`.trim().length > 0 &&
                        <div className="flyer-lead">
                            {fill(fields.lead, { name: this.name(), site, discount: `${fields.discount}`.trim() })}
                        </div>
                    }

                    {fields.withAddress && this.address().length > 0 &&
                        <div className="flyer-place">
                            <span style={{ color: fields.accent }}>{pinIcon()}</span>
                            {this.address()}
                        </div>
                    }

                </div>

                <div className="flyer-band" style={{ background: fields.accent, color: fields.band }}>
                    <div className="flyer-band-site">{site}</div>
                    <div className="flyer-band-text">{fields.strip}</div>
                </div>

            </div>
        )
    }

    /* THE BACK — how the discount is taken and the code itself */
    _back = () => {

        /* Fields */
        const { fields, organization } = this.props

        const steps = [fields.first, fields.second, fields.third]
        const values = { name: this.name(), site: "bookify.kz", discount: `${fields.discount}`.trim() }

        return (
            <div className="flyer-back">

                <div className="flyer-back-inner">

                    <img src="/images/bookify.png" alt="Bookify" className="flyer-bookify" />

                    <div className="flyer-how">
                        {fields.how} <span style={{ color: fields.accent }}>{`${fields.discount}`.trim()}%</span>
                    </div>

                    <div className="flyer-steps">
                        {steps.map((step, index) => {

                            if (`${step}`.trim().length === 0) {
                                return null
                            }

                            return (
                                <div className="flyer-step" key={`${index}`}>
                                    <div className="flyer-step-number" style={{ background: fadeOf(fields.accent, 0.14), color: fields.accent }}>{index + 1}</div>
                                    <div className="flyer-step-text">{fill(step, values)}</div>
                                </div>
                            )
                        })}
                    </div>

                    <div
                        className={`flyer-scan ${fields.card}`}
                        style={fields.card === "tint" ? { background: fadeOf(fields.accent, 0.09) } : {}}
                    >

                        <div className="flyer-scan-code">
                            <QRCodeSVG value={linkOf(organization, fields.link)} level="Q" size={150} />
                        </div>

                        <div className="flyer-scan-inner">
                            <div className="flyer-scan-title" style={fields.card === "tint" ? { color: fields.accent } : {}}>{fields.scanTitle}</div>
                            <div className="flyer-scan-text">{fields.scanText}</div>
                        </div>

                    </div>

                    <div className="flyer-sign">

                        {this._brand("small")}

                        <div className="flyer-sign-inner">

                            {fields.withTagline && `${fields.tagline}`.trim().length > 0 &&
                                <div className="flyer-sign-tagline">{fields.tagline}</div>
                            }

                            {fields.withAddress && this.address().length > 0 &&
                                <div className="flyer-sign-place">
                                    <span style={{ color: fields.accent }}>{pinIcon()}</span>
                                    {this.address()}
                                </div>
                            }

                        </div>

                    </div>

                    {fields.withFine && `${fields.fine}`.trim().length > 0 &&
                        <div className="flyer-fine">{fields.fine}</div>
                    }

                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { fields, side, nodeID, photo } = this.props

        /* The photo lies under the letters of the face only, and only while it is asked for */
        let background = {}

        if (side === "front") {

            if (fields.veil === "none" || !photo) {
                background = { background: fields.veil === "light" ? "#F3EDEC" : "#141414" }
            }
            else {
                background = { backgroundImage: `url(${photo})` }
            }
        }

        return (
            <div id={nodeID} className={`flyer-sheet ${side} ${fields.type} veil-${fields.veil}`} style={{ width: CANVAS.width, height: CANVAS.height }}>

                {side === "front" && <div className="flyer-photo" style={background} />}
                {side === "front" && photo && fields.veil !== "none" && <div className="flyer-veil" />}

                {this._rule()}

                {side === "front" ? this._front() : this._back()}

            </div>
        )
    }
}

export default FlyerSheet
